import { ChangeDetectionStrategy, Component, Input, Signal, signal } from '@angular/core';
import { AdvancedMultiSelectBase } from 'src/app/common-components/multi-select/advanced-multi-select-base.directive';
import { RoleOption } from 'src/app/pages/role-register/models/role-option.interface';
import { roleOptionActions } from '../state/role-option.actions';
import { roleOptionSelectors } from '../state/role-option.reducer';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-role-advanced-multi-select',
    templateUrl: './role-advanced-multi-select.component.html',
    standalone: false
})
export class RoleAdvancedMultiSelectComponent extends AdvancedMultiSelectBase<RoleOption> {
   @Input() set accountIdFilter(value: number | null) {
      this.options.loadFilters = [value ? `AccountId = ${value}` : 'AccountId Is Null'];
   }

   labelSignal: Signal<string> = signal('Roles');

   itemTrackBy = (role: RoleOption) => role.roleId;

   constructor() {
      super({
         loadAction: roleOptionActions.load,
         loadFilters: [],
         searchAction: roleOptionActions.search,
         searchResetAction: roleOptionActions.searchReset,
         selectFilteredItems: roleOptionSelectors.selectFilteredItems,
         selectCallState: roleOptionSelectors.selectCallState,
      });
   }

   isRoleSelected(selectedRoles: RoleOption[], role: RoleOption) {
      return selectedRoles.some((r) => {
         return this.itemTrackBy(r) === this.itemTrackBy(role);
      });
   }
}
